import { create } from "zustand";

export type NavigationState = {
    sidebarIsOpen: boolean;
    sidebarIsHidden: boolean;
    searchIsOpen: boolean;
    helpIsOpen: boolean;
    setSearchIsOpen: (searchIsOpen: boolean) => void;
    setHelpIsOpen: (helpIsOpen: boolean) => void;
    setSidebarIsOpen: (sidebarIsOpen: boolean) => void;
    setSidebarIsHidden: (sidebarIsHidden: boolean) => void;
};

export const useNavigationStore = create<NavigationState>()((set) => ({
    sidebarIsOpen: false,
    sidebarIsHidden: true,
    searchIsOpen: false,
    helpIsOpen: false,
    setSearchIsOpen: (searchIsOpen: boolean) => set({ searchIsOpen }),
    setHelpIsOpen: (helpIsOpen: boolean) => set({ helpIsOpen }),
    setSidebarIsOpen: (sidebarIsOpen: boolean) => {
        set({ sidebarIsOpen });
        localStorage.setItem("sidebarIsOpen", sidebarIsOpen.toString());
    },
    setSidebarIsHidden: (sidebarIsHidden: boolean) => {
        set({ sidebarIsHidden, sidebarIsOpen: true });
    },
}));
